import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProjectAdmin from '../views/projectAdmin/index.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'child',
  component: Home,
  children: [{
    path: '/ProjectAdmin/index',
    name: 'ProjectAdmin',
    component: ProjectAdmin,
  }]
}]

const router = new VueRouter({
  mode: 'history',
  base: window.__POWERED_BY_QIANKUN__ ? '/app1' : process.env.BASE_URL,
  routes
})

export default router
